import { format, parse } from "date-fns";
import { ko } from "date-fns/locale";

type FdWeekStartsOn = 0 | 1; // Fooding 시스템은 일(0) 또는 월(1) 시작만 허용

/**
 *
 * @param dateString 'YYYYMMDD'
 * @param weekStartsOn
 * @returns
 */
export function convToDateFromYearMonthDate01(
  dateString: string,
  weekStartsOn: FdWeekStartsOn = 1
): Date {
  return parse(dateString, "yyyyMMdd", new Date(), {
    locale: ko,
    weekStartsOn,
  });
}

/**
 *
 * @param dateString 'YYYY-MM'
 * @returns
 */
export function convToDateFromYearMonth(yyyyMM?: string | null) {
  if (!yyyyMM) return;

  return parse(yyyyMM, "yyyy-MM", new Date());
}

/**
 *
 * @param date
 * @param weekStartsOn
 * @returns 'YYYY-MM-DD'
 */
export function convDateToYearMonthDate01(
  date?: Date | null,
  weekStartsOn: FdWeekStartsOn = 1
): string | undefined {
  if (!date) return;
  return format(date, "yyyy-MM-dd", {
    locale: ko,
    weekStartsOn,
  });
}

export function convDateFilterStart(
  date?: Date | null,
  weekStartsOn: FdWeekStartsOn = 1
): string | undefined {
  if (!date) return;
  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0);
  return format(date, "yyyy-MM-dd HH:mm:ss", {
    locale: ko,
    weekStartsOn,
  });
}
export function convDateFilterEnd(
  date?: Date | null,
  weekStartsOn: FdWeekStartsOn = 1
): string | undefined {
  if (!date) return;
  date.setHours(23);
  date.setMinutes(59);
  date.setSeconds(59);
  return format(date, "yyyy-MM-dd HH:mm:ss", {
    locale: ko,
    weekStartsOn,
  });
}

/**
 *
 * @param date
 * @param weekStartsOn
 * @returns 'YYYY-MM'
 */
export function convToStringFromDateForYearMonth(
  date?: Date | null,
  weekStartsOn: FdWeekStartsOn = 1
): string | undefined {
  if (!date) return;
  return format(date, "yyyy-MM", {
    locale: ko,
    weekStartsOn,
  });
}

/**
 * yyyyMMdd
 * @param date
 * @param weekStartsOn
 * @returns
 */
export function presentToYyyyMmDd(
  date: Date,
  weekStartsOn: FdWeekStartsOn = 1
): string {
  if (!date) {
    return "--------";
  }

  return format(date, "yyyyMMdd", {
    locale: ko,
    weekStartsOn,
  });
}
